import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
    background-color: #F3F3F3;
    padding-top:1em;
    padding-bottom: 5em;

    @media all and (max-width: ${vars.mobileL}) {
        padding: 5em 2em;
    }

    @media all and (max-width: ${vars.mobileM}) {
        padding: 2em 0;
    }
`;